import(/* webpackMode: "eager", webpackExports: ["ClientPage"] */ "/vercel/path0/src/app/client.tsx");
